import ky from 'ky';

const apiClient = ky.create({
  prefixUrl: process.env.REACT_APP_BASE_URL,
  // prefixUrl: 'http://127.0.0.1:8000/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
